import { all, fork } from 'redux-saga/effects'
import analyticsSagas from './analytics/analytics'
import cartSagas from './cart/cart'
import dashboardSagas from './dashboard/dashboard'
import draftSagas from './draft/draft'
import entitlementSaga from './entitlement/entitlement'
import jobsSagas from './jobs/jobs'
import uiSagas from './ui/ui'
import userSagas from './user/user'
import webshopSagas from './webshop/webshop'
import jobSagas from './job/job'

export default function* saga() {
  yield all([
    fork(analyticsSagas),
    fork(cartSagas),
    fork(dashboardSagas),
    fork(draftSagas),
    fork(entitlementSaga),
    fork(jobsSagas),
    fork(userSagas),
    fork(uiSagas),
    fork(webshopSagas),
    fork(jobSagas),
  ])
}
